import { Typography, Box } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import Preloader from 'components/Preloader';
import Private from 'components/Private';
import useResumePauseActions from 'components/PauseResume/hooks/useResumePauseActions';

function ResumePauseButton({
  hasConnectProvider,
  modalTitle = '',
  providerAll = 'all',
  isOpen = false,
  id = '',
}) {
  const {
    handleShowResumePause,
    statusStyle,
    isBrandLoading,
    stopResumeOrders,
  } = useResumePauseActions(modalTitle, providerAll, isOpen);

  if (!hasConnectProvider && !stopResumeOrders?.loading && !isBrandLoading) {
    return (
      <Private permission="MENU_VIEW">
        <LoadingButton
          id="resumePauseButton"
          size="small"
          variant="outlined"
          sx={{
            color: 'black',
            textTransform: 'none',
            height: '40px',
            width: '100%',
            minWidth: '240px',
            maxWidth: '240px',
            borderColor: 'rgba(0, 0, 0, 0.23)',
          }}
          disabled={true}
        >
          <Typography sx={{ display: 'flex', alignItems: 'center' }}>
            N/A
          </Typography>
        </LoadingButton>
      </Private>
    );
  }

  return (
    <Private permission="MENU_VIEW">
      <LoadingButton
        id="resumePauseButton"
        size="small"
        aria-describedby={id}
        onClick={handleShowResumePause}
        variant="outlined"
        loading={false}
        startIcon={
          !isBrandLoading &&
          !stopResumeOrders.loading &&
          statusStyle?.statusName &&
          Object.keys(statusStyle).length > 0 && (
            <Box
              sx={{
                background: statusStyle?.backgroundColor || '',
                borderColor: statusStyle?.borderColor || '',
                border: `2px solid ${statusStyle?.borderColor || ''}`,
                width: 12,
                height: 12,
                borderRadius: 90,
              }}
            />
          )
        }
        sx={{
          color: 'black',
          textTransform: 'none',
          height: '40px',
          width: '100%',
          minWidth: '240px',
          maxWidth: '240px',
          borderColor: 'rgba(0, 0, 0, 0.23)',
        }}
      >
        {stopResumeOrders.loading || isBrandLoading ? (
          <Preloader />
        ) : (
          <Typography sx={{ display: 'flex', alignItems: 'center' }}>
            {statusStyle?.statusName || ''}
          </Typography>
        )}
      </LoadingButton>
    </Private>
  );
}

export default ResumePauseButton;
